import { Col, Descriptions, Row } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { formatPhone } from "../shared/formatting";

const RenewalCustomerPanel = ({ selected }) => {
  const maskSensitiveData = useSelector(
    (state) => state.actor?.details?.data?.MaskSensitiveData
  );

  const maskable = (text) => (
    <div className={maskSensitiveData === true ? "blurry-text" : ""}>
      {text}
    </div>
  );

  const formatAddress = (data) => {
    if (!data) return "";
    const { CustomerAddr1, CustomerAddr2, CustomerAddr3, City, ProvinceCode, PostalCode } = data;
    return [CustomerAddr1, CustomerAddr2, CustomerAddr3, City, ProvinceCode, PostalCode]
      .filter((part) => part && part.trim())
      .join(", ");
  };

  const hasValue = (value) =>
    value !== null && value !== undefined && String(value).trim() !== "";

  const items = [
    {
      key: "customer",
      label: "Customer",
      children: maskable(selected?.InsuredName),
    },
    {
      key: "address",
      label: "Address",
      children: maskable(formatAddress(selected)),
    },
    {
      key: "cdf",
      label: "CDF",
      children: maskable(selected?.CDF),
    },
    {
      key: "principalOperator",
      label: "Principal Driver",
      children: maskable(selected?.PrincipalOperator),
    },
    {
      key: "phone",
      label: "Phone",
      children: maskable(
        selected?.CustomerPhone && formatPhone(selected.CustomerPhone),
      ),
    },
    {
      key: "lessorName",
      label: "Lessor",
      children: maskable(selected.LessorName),
    },
    {
      key: "principalOperatorBCDL",
      label: "Principal Driver DL#",
      children: maskable(selected?.PrincipalOperatorBCDL),
    },

    {
      key: "email",
      label: "Email",
      children: maskable(selected?.Email),
    },
  ];

  return (
    <Row>
      <Col span={24}>
        {selected && (
          <Descriptions
            size="small"
            column={3}
            items={items}
          />
        )}
      </Col>
    </Row>
  );
};

export default RenewalCustomerPanel;
